import { useFeatureFlagsContext } from '@/@feature-flags/context';

/**
 * Returns whether a single feature flag is enabled for the current user.
 * Returns `false` for unknown or unfetched keys.
 */
export function useFeatureFlag(key: string): boolean {
    const { hasFlag } = useFeatureFlagsContext();
    return hasFlag(key);
}
